import { anyApi } from "convex/server";

export const api = anyApi;
